import { post } from '@core/api/baseApi';

export interface MergeStudiesRequest {
  targetStudyInstanceUid: string;
  sourceStudyInstanceUids: string[];
}

const mergeStudies = async (request: MergeStudiesRequest): Promise<{ success: boolean }> => {
  return await post('/Studies/merge', request);
};

export default mergeStudies;
